module.exports = __webpack_public_path__ + "img/no_user.38cb22b2.svg";